module.exports = __webpack_public_path__ + "media/images/icon__breadcrumbs-arrow-left--rb-raven-gray@2x-06ccd895b2d31a0b6b5780729051fd19.png";